import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/PasswordReset.js";
import TpicPage from "./TpicPage";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Card, CardHeader, CardContent, Grid, Button, CircularProgress, TextField } from '@material-ui/core';
import { withRouter } from "react-router-dom";
import { BASE_URIS, Q_STRING } from "../domain/constants";
import { RESETCODE, RESETPASS, HOMEPAGE } from "../Routes";
import Util, { getSelectedPartner } from "../../util/Util";
import { Dialog } from "../common";
import queryString from "query-string";
import { retrieveFromQueryString } from "../../util/QueryStringUtil";
import { validateUserDefinedPassword, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from "../../util/PasswordUtil";
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw',
    height: '100%',
    marginTop: '10vh'
  },
  paddedCard: {
    padding: '20px'
  }
});
const MODE = {
  resetCode: 'resetCode',
  // User 'requests' a reset code
  mailError: 'mailError',
  // For whatever reason, mail send failed
  checkMail: 'checkMail',
  // Direct user to check mail for code
  resetPass: 'resetPass' // Allow user to input code to reset password
};
class PasswordReset extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      this.state[name] = event.target.value;
      this.forceUpdate();
    });
    _defineProperty(this, "handleSubmit", () => {
      // compare two passwords to make sure they match
      if (this.validateSubmission()) {
        const passwordsMatch = this.passwordsMatch();
        if (passwordsMatch === true) {
          const validationResult = validateUserDefinedPassword(this.state.newPassword);
          if (validationResult != null && validationResult.length === 0) {
            this.sendResetRequest();
          }
          this.setState({
            validationResult
          });
        } else {
          this.setState({
            passwordsMatch
          });
        }
      }
    });
    _defineProperty(this, "handleKeyPress", e => {
      if (e.key === 'Enter') {
        this.handleSubmit();
      }
    });
    this.state = {
      mode: null,
      resetProcessing: false,
      fromEmailLink: false,
      // set true if they navigated here from the email link, so that we can populate the reset code
      resetCode: null,
      resetCodeInvalid: false,
      oldPassword: null,
      oldPasswordInvalid: false,
      newPassword: null,
      confirmNewPassword: null,
      passwordsMatch: null,
      validationResult: null
    };
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
    this.determinePageMode();
  }
  componentDidMount() {
    if (this.state.mode === MODE.resetCode) {
      this.sendInitialResetMailRequest();
      this.forceUpdate();
    }
    if (this.state.mode === MODE.resetPass || this.props.location != null && this.props.location.pathname === RESETPASS) {
      this.determineResetCodeFromQueryStringIfPossible();
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("now we're in mode " + this.state.mode);

    // if the page has changed or the mode has changed
    if (this.props != null && this.props.location != null && (this.props.location.pathname !== prevProps.location.pathname || this.props.location.key !== prevProps.location.key) || prevState.mode !== this.state.mode) {
      this.determinePageMode();
      this.forceUpdate();
      if (this.state.mode === MODE.resetCode
      // && (prevState.mode != null && prevState.mode !== this.state.mode)
      ) {
        this.sendInitialResetMailRequest();
        this.forceUpdate();
      }
      if (this.state.mode === MODE.resetPass) {
        this.determineResetCodeFromQueryStringIfPossible();
        this.forceUpdate();
      }
    }
  }
  determineResetCodeFromQueryStringIfPossible() {
    const querystringValues = queryString.parse(this.props.location.search);
    const resetCode = retrieveFromQueryString(Q_STRING.RESET_CODE, querystringValues);
    if (resetCode != null && resetCode !== '') {
      this.setState({
        resetCode
      });
    }
  }
  determinePageMode() {
    const pathname = this.props.location.pathname;
    if (pathname === RESETCODE) {
      this.state.mode = MODE.resetCode;
    } else if (pathname === RESETPASS) {
      this.state.mode = MODE.resetPass;
    }
  }

  /**
   * Send an email with a reset code to the user
   */
  sendInitialResetMailRequest() {
    fetch(BASE_URIS.resetCode, {
      method: 'POST',
      credentials: "include"
    }).then(resp => {
      if (resp.ok === true) {
        this.state.mode = MODE.checkMail;
        this.forceUpdate();
      } else {
        Util.createDialog("Failed to send email", "Please contact the TPIC team", this.dialogRef);
        this.state.mode = MODE.mailError;
        this.forceUpdate();
      }
    }).catch(err => {
      console.error(err);
      this.state.mode = MODE.mailError;
      this.forceUpdate();
    });
  }
  sendResetRequest() {
    fetch(BASE_URIS.resetPass, {
      method: 'POST',
      credentials: "include",
      body: JSON.stringify({
        resetCode: this.state.resetCode,
        oldPassword: this.state.oldPassword,
        newPassword: this.state.newPassword
      }),
      headers: {
        'Content-Type': 'application/json',
        'x-meta-tpic-partner': getSelectedPartner()
      }
    }).then(resp => {
      if (resp.ok === true) {
        Util.createDialog("Password was reset!", "Successfully changed your password.", this.dialogRef);
        this.navigateTo(HOMEPAGE);
      } else {
        if (resp.status === 400) {
          Util.createDialog("Password reset was unsuccessful", "Reset Code was incorrect", this.dialogRef);
          this.state.resetCodeInvalid = true;
          this.forceUpdate();
        } else if (resp.status === 401) {
          Util.createDialog("Password reset was unsuccessful", "Old password was incorrect.", this.dialogRef);
          this.state.oldPasswordInvalid = true;
          this.forceUpdate();
        } else if (resp.status === 403) {
          Util.createDialog("Password reset was unsuccessful", "You are forbidden from resetting this user's password.", this.dialogRef);
        } else if (resp.status === 404) {
          Util.createDialog("Password reset was unsuccessful", "User was not found in TPIS.", this.dialogRef);
        }
      }
    }).catch(err => {
      console.error(err);
      this.state.mode = MODE.mailError;
      this.forceUpdate();
    });
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      mode = _this$state.mode,
      passwordsMatch = _this$state.passwordsMatch,
      resetCode = _this$state.resetCode,
      fromEmailLink = _this$state.fromEmailLink,
      resetCodeInvalid = _this$state.resetCodeInvalid,
      oldPasswordInvalid = _this$state.oldPasswordInvalid,
      validationResult = _this$state.validationResult;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 13
      }
    }, mode === null && /*#__PURE__*/React.createElement(Card, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 189,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 190,
        columnNumber: 25
      }
    }))), mode === MODE.resetCode && /*#__PURE__*/React.createElement(Card, {
      className: classes.paddedCard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 195,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardHeader, {
      title: "Sending Reset Email",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 197,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignItems: "center",
      spacing: 1,
      alignContent: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 198,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 29
      }
    })))), mode === MODE.checkMail && /*#__PURE__*/React.createElement(Card, {
      className: classes.paddedCard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 206,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardHeader, {
      title: "Check Your Email",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 207,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 208,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: 'center',
      alignItems: 'center',
      alignContent: 'center',
      direction: 'column',
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 209,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 211,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 212,
        columnNumber: 33
      }
    }, "A reset code has been sent to the email address associated with your account.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 216,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 217,
        columnNumber: 33
      }
    }, "Please click", /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      onClick: () => this.navigateTo(RESETPASS),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 219,
        columnNumber: 37
      }
    }, "here"), "when you have received your code.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 223,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 224,
        columnNumber: 33
      }
    }, "Click", /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      onClick: () => {
        this.setState({
          mode: MODE.resetCode
        });
        this.navigateTo(RESETCODE);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 226,
        columnNumber: 37
      }
    }, "here"), "if you need a new code."))))), mode === MODE.resetPass && /*#__PURE__*/React.createElement(Card, {
      className: classes.paddedCard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 238,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardHeader, {
      title: "Reset Password",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 239,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: 'center',
      alignItems: 'center',
      alignContent: 'center',
      direction: 'column',
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 241,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 243,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 244,
        columnNumber: 33
      }
    }, "Input your reset code if it is not automatically filled")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleChange('resetCode'),
      variant: 'outlined',
      label: 'Reset Code',
      value: resetCode,
      autofocus: fromEmailLink === false,
      error: resetCodeInvalid === true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 248,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 252,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleChange('oldPassword'),
      variant: 'outlined',
      label: 'Old Password',
      type: 'password',
      autofocus: fromEmailLink === true,
      error: oldPasswordInvalid === true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253,
        columnNumber: 33
      }
    })), validationResult != null && validationResult.length > 0 && this.getMessageForValidationResult(validationResult).map(message => /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 259,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      color: 'error',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 260,
        columnNumber: 37
      }
    }, message))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 264,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleChange('newPassword'),
      variant: 'outlined',
      label: 'New Password',
      type: 'password',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 265,
        columnNumber: 33
      }
    })), passwordsMatch === false && [/*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 270,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      color: 'error',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 271,
        columnNumber: 37
      }
    }, "Passwords do not match.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 273,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      color: 'error',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 274,
        columnNumber: 37
      }
    }, "Please retype your password and try again"))], /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 279,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: this.handleChange('confirmNewPassword'),
      variant: 'outlined',
      label: 'Confirm New Password',
      type: 'password',
      error: passwordsMatch === false,
      onKeyPress: this.handleKeyPress,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 280,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 284,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.handleSubmit(),
      variant: 'outlined',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 285,
        columnNumber: 33
      }
    }, "Submit"))))), mode === MODE.mailError && /*#__PURE__*/React.createElement(Card, {
      className: classes.paddedCard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 292,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardHeader, {
      title: "Email Send Error",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 293,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 294,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 295,
        columnNumber: 25
      }
    }, "There was an issue sending mail to your account. Please contact support or try again later."))), /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 300,
        columnNumber: 17
      }
    }));
  }
  navigateTo(target) {
    this.props.history.push(target);
  }
  passwordsMatch() {
    const _this$state2 = this.state,
      newPassword = _this$state2.newPassword,
      confirmNewPassword = _this$state2.confirmNewPassword;
    if (newPassword === null || confirmNewPassword === null) {
      return false;
    }
    let pass = newPassword.trim();
    let conf = confirmNewPassword.trim();
    return pass !== '' && conf !== '' && pass === conf;
  }
  validateSubmission() {
    const _this$state3 = this.state,
      resetCode = _this$state3.resetCode,
      oldPassword = _this$state3.oldPassword,
      newPassword = _this$state3.newPassword,
      confirmNewPassword = _this$state3.confirmNewPassword;
    if (resetCode == null || resetCode === '') {
      Util.createDialog("Missing field", "Reset Code field can not be left blank", this.dialogRef);
      return false;
    } else if (oldPassword == null || oldPassword === '') {
      Util.createDialog("Missing field", "Old Password field can not be left blank", this.dialogRef);
      return false;
    } else if (newPassword == null || newPassword === '') {
      Util.createDialog("Missing field", "New Password field can not be blank", this.dialogRef);
      return false;
    } else if (confirmNewPassword == null || confirmNewPassword === '') {
      Util.createDialog("Missing field", "Confirm New Password field can not be blank", this.dialogRef);
      return false;
    }
    return true;
  }
  getMessageForValidationResult(validationResult) {
    let messageArray = [];
    if (validationResult.includes('min')) {
      messageArray.push("Password must have a minimum length of ".concat(PASSWORD_MIN_LENGTH));
    }
    if (validationResult.includes('max')) {
      messageArray.push("Password must have a maximum length of ".concat(PASSWORD_MAX_LENGTH));
    }
    if (validationResult.includes('lowercase')) {
      messageArray.push("Password must include at least one lowercase letter");
    }
    if (validationResult.includes('uppercase')) {
      messageArray.push("Password must include at least one uppercase letter");
    }
    if (validationResult.includes('digits')) {
      messageArray.push("Password must include at least one digit");
    }
    if (validationResult.includes('spaces')) {
      messageArray.push("Password can not include spaces");
    }
    return messageArray;
  }
}
export default withStyles(styles)(withRouter(PasswordReset));